import { render } from "./AddInvestmentPage.vue?vue&type=template&id=08ca2bac&scoped=true"
import script from "./AddInvestmentPage.vue?vue&type=script&lang=js"
export * from "./AddInvestmentPage.vue?vue&type=script&lang=js"

import "./AddInvestmentPage.vue?vue&type=style&index=0&id=08ca2bac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ca2bac"]])

export default __exports__